// Unpublished Work © 2023-2024 Deere & Company.

import { Box, Card, CardContent, SxProps, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Address as ShippingAddress } from "../../api/invoices/interfaces";
import NoDataAvailableError from "../../pages/orders/components/NoDataAvailableError/NoDataAvailableError";
import LoadingIndicator from "../LoadingIndicator/LoadingIndicator";

const Address = ({
  shippingAddress,
  showLoader,
  type,
  pageName = "order",
  sx,
  contentSx = { height: "300px" },
}: {
  shippingAddress: ShippingAddress | undefined;
  showLoader: boolean;
  type: string;
  pageName?: string;
  sx?: SxProps;
  contentSx?: SxProps;
}) => {
  const theme = useTheme();
  const identifier = `${type.replace(/\s/g, "")}-${pageName}`;

  return (
    <Box width="100%" paddingTop={theme.tokens.FuelSpacing4}>
      <Card sx={sx}>
        <CardContent sx={contentSx}>
          <Typography
            sx={{
              fontWeight: "600",
              color: theme.tokens.FuelColorTextPrimary,
            }}
            variant="h4"
            data-testid={`${identifier}-addressType`}
          >
            {type}
          </Typography>

          {showLoader && <LoadingIndicator />}

          {!showLoader &&
            (shippingAddress ? (
              <Box paddingTop={theme.tokens.FuelSpacing4}>
                <Typography data-testid={`${identifier}-addressLine1`}>
                  {shippingAddress.addressLine1}
                </Typography>

                <Typography data-testid={`${identifier}-addressLine2`}>
                  {shippingAddress.addressLine2}
                </Typography>

                <Typography data-testid={`${identifier}-addressLine3`}>
                  {shippingAddress.cityName}
                  {shippingAddress.stateOrProvince ? ", " : ""}
                  {shippingAddress.stateOrProvince}{" "}
                  {shippingAddress.postalOrZipCode}
                </Typography>

                <Typography
                  data-testid={`${identifier}-address-countryCode-phoneNumber`}
                >
                  {shippingAddress.countryCode}
                  {shippingAddress.phoneNumber ? "-" : ""}
                  {shippingAddress.phoneNumber}
                </Typography>
              </Box>
            ) : (
              <NoDataAvailableError />
            ))}
        </CardContent>
      </Card>
    </Box>
  );
};

export default Address;
